import { useMediaQuery, useTheme } from "@mui/material";

export type Breakpoints = {
  smOrUp: boolean;
  mdOrUp: boolean;
  lgOrUp: boolean;
};

export function useBreakpoints(): Breakpoints {
  const theme = useTheme();
  const smOrUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdOrUp = useMediaQuery(theme.breakpoints.up("md"));
  const lgOrUp = useMediaQuery(theme.breakpoints.up("lg"));
  return { smOrUp, mdOrUp, lgOrUp };
}
